import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// Intercept all image src loads and background-images to automatically prefix subfolder hosting path
// (function () {
//   const publicUrl = process.env.PUBLIC_URL || "";
//   if (!publicUrl) return;

//   const imageSrcDescriptor = Object.getOwnPropertyDescriptor(
//     HTMLImageElement.prototype,
//     "src",
//   );
//   if (imageSrcDescriptor && imageSrcDescriptor.set) {
//     const originalSet = imageSrcDescriptor.set;
//     Object.defineProperty(HTMLImageElement.prototype, "src", {
//       set: function (val) {
//         if (typeof val === "string") {
//           if (val.startsWith("/img/")) {
//             val = publicUrl + val;
//           } else if (val.startsWith(window.location.origin + "/img/")) {
//             val = val.replace(
//               window.location.origin + "/img/",
//               window.location.origin + publicUrl + "/img/",
//             );
//           }
//         }
//         originalSet.call(this, val);
//       },
//       get: imageSrcDescriptor.get,
//       configurable: true,
//     });
//   }

//   const originalSetAttribute = Element.prototype.setAttribute;
//   Element.prototype.setAttribute = function (name, value) {
//     if (name === "src" && this.tagName === "IMG" && typeof value === "string") {
//       if (value.startsWith("/img/")) {
//         value = publicUrl + value;
//       }
//     }
//     return originalSetAttribute.call(this, name, value);
//   };

//   const originalSetProperty = CSSStyleDeclaration.prototype.setProperty;
//   CSSStyleDeclaration.prototype.setProperty = function (
//     property,
//     value,
//     priority,
//   ) {
//     if (
//       (property === "background-image" || property === "backgroundImage") &&
//       typeof value === "string"
//     ) {
//       if (value.includes('url("/img/')) {
//         value = value.replace('url("/img/', `url("${publicUrl}/img/`);
//       } else if (value.includes("url('/img/")) {
//         value = value.replace("url('/img/", `url('${publicUrl}/img/`);
//       } else if (value.includes("url(/img/")) {
//         value = value.replace("url(/img/", `url(${publicUrl}/img/`);
//       }
//     }
//     return originalSetProperty.call(this, property, value, priority);
//   };

//   const styleBgDescriptor =
//     Object.getOwnPropertyDescriptor(
//       CSSStyleDeclaration.prototype,
//       "backgroundImage",
//     ) ||
//     Object.getOwnPropertyDescriptor(
//       CSSStyleDeclaration.prototype,
//       "background-image",
//     );
//   if (styleBgDescriptor && styleBgDescriptor.set) {
//     const originalSet = styleBgDescriptor.set;
//     Object.defineProperty(CSSStyleDeclaration.prototype, "backgroundImage", {
//       set: function (val) {
//         if (typeof val === "string") {
//           if (val.includes('url("/img/')) {
//             val = val.replace('url("/img/', `url("${publicUrl}/img/`);
//           } else if (val.includes("url('/img/")) {
//             val = val.replace("url('/img/", `url('${publicUrl}/img/`);
//           } else if (val.includes("url(/img/")) {
//             val = val.replace("url(/img/", `url(${publicUrl}/img/`);
//           }
//         }
//         originalSet.call(this, val);
//       },
//       get: styleBgDescriptor.get,
//       configurable: true,
//     });
//   }
// })();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
